// English — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const en: Record<string, string> = {
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.close": "Close",
  "common.back": "Back",
  "common.done": "Done",
  "common.yes": "Yes",
  "common.no": "No",
  "common.confirm": "Confirm",
  "common.search": "Search",
  "common.retry": "Retry",
  "common.loading": "Loading…",
  "common.offline": "Offline",
  "nav.settings": "Settings",
  "nav.orders": "Orders",
  "nav.tables": "Tables",
  "nav.menu": "Menu",
  "nav.reports": "Reports",
  "roles.pos": "Point of Sale",
  "roles.kds": "Kitchen Display",
  "roles.customer": "Customer Display",
  "roles.captain": "Captain",
  "roles.kiosk": "Self-order Kiosk",
  "order.dineIn": "Dine-in",
  "order.takeaway": "Takeaway",
  "order.delivery": "Delivery",
  "order.quickBill": "Quick bill",
  "order.newOrder": "New order",
  "order.sendToKitchen": "Send to kitchen",
  "order.addItem": "Add item",
  "order.cart": "Cart",
  "order.empty": "No items yet",
  "bill.settle": "Settle bill",
  "bill.subtotal": "Subtotal",
  "bill.discount": "Discount",
  "bill.total": "Total",
  "bill.gst": "GST",
  "bill.customerName": "Customer name",
  "bill.token": "Token",
  "bill.billNo": "Bill no",
  "bill.splitBill": "Split bill",
  "bill.splitBySeat": "Split by seat",
  "bill.pay": "Pay",
  "bill.print": "Print",
  "bill.paid": "Paid",
  "bill.pending": "Pending",
  "table.free": "Free",
  "table.occupied": "Occupied",
  "table.transfer": "Transfer",
  "table.merge": "Merge",
  "settings.language": "Language",
  "settings.tax": "Tax",
  "settings.printing": "Printing",
  "settings.account": "Account & Plan",
  "settings.general": "General",
  "settings.deviceMode": "Device mode",
  "settings.chooseLanguage": "Choose language",
  "nav.order": "Order",
  "nav.online": "Online",
  "nav.activity": "Activity",
  "nav.history": "History",
  "nav.import": "Import",
  "nav.endShift": "End shift",
  "settings.title": "Settings",
  "settings.subtitle": "Outlet, tax, printers, roles & bill format",
  "settings.sectionOutlet": "Outlet & Branding",
  "settings.sectionTax": "Tax & GST",
  "settings.sectionPrinters": "Printers & KOT",
  "settings.sectionRoles": "Roles & Permissions",
  "settings.sectionBillFormat": "Bill Format",
  "settings.sectionChannels": "Online Channels",
  "settings.sectionAccount": "Account & Plans",
  "settings.sectionAbout": "About & Updates",
  "order.viewCart": "View cart",
  "order.categories": "Categories",
  "order.tapToBuild": "Tap dishes to build the order",
  "order.addNote": "Add note",
  "order.searchDishes": "Search dishes",
  "bill.settleAndPrint": "Settle & Print",
  "menu.title": "Menu & Items",
  "menu.searchItems": "Search items…",
  "menu.noItems": "No items here",
  "menu.addItemBtn": "Add Item",
  "menu.tapAddItem": "Tap “Add Item” to create one",
  "menu.addCategory": "Add category",
  "menu.newCategory": "New category",
  "order.allFired": "All items fired",
  "bill.settling": "Settling…"
};

export default en;
